import { Select, SelectOptionType } from '@octano/global-ui';
import { useCallback, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Col, Container, Row } from 'reactstrap';
import { TranslationsKeys } from '../../../locales/translations';
import { useWarningsSummaryDataLoader } from '../loaders/StudentWarningsSummaryDataLoader';
import { useWarningsSummaryFormLoaderData } from '../loaders/StudentWarningsSummaryFormLoader';

const StudentWarningsSummaryMainFilter = () => {
  const { t } = useTranslation(TranslationsKeys.STUDENT_ALERTS_SUMMARY);
  const data = useWarningsSummaryFormLoaderData();
  const { loading, query, updateQuery } = useWarningsSummaryDataLoader();

  const handleChangeFilter = useCallback(
    (key: keyof typeof query, option: SelectOptionType) => {
      let nextQuery = { ...query, [key]: option.value as string, page: 1 };
      updateQuery(nextQuery);
    },
    [updateQuery, query],
  );

  useEffect(() => {
    if (query && !query?.schoolId && data?.schools?.length === 1) {
      updateQuery({
        ...query,
        schoolId: data?.schools[0].value as string,
        page: 1,
        riskLevel: undefined,
        studyPlanId: undefined,
        campusId: undefined,
        periodId: undefined,
        year: undefined,
        name: undefined,
        startAt: undefined,
        endAt: undefined,
      });
    }
  }, [query, data.schools, updateQuery]);

  useEffect(() => {
    if (query) {
      localStorage.setItem('@studentAlerts/filters', JSON.stringify(query));
    }
  }, [query]);

  return (
    <Container fluid>
      <Row className="pb-4 gutters-filters">
        <Col xs={12}>
          <p>{t('filters.prefix')}</p>
        </Col>
        <Col xs={12} md={4}>
          <Select
            value={data?.schools?.find((e) => e.value === query.schoolId)}
            name="school"
            options={data.schools}
            label={t('filters.school.label')}
            placeholder={t('filters.school.placeholder')}
            onChange={handleChangeFilter.bind(null, 'schoolId')}
            isClearable={false}
            disabled={loading || data.schools.length < 1}
          />
        </Col>
        <Col xs={12} md={4}>
          <Select
            value={data?.years?.find((e) => e.value === query.year)}
            name="year"
            options={data.years}
            label={t('filters.year.label')}
            placeholder={t('filters.year.placeholder')}
            onChange={handleChangeFilter.bind(null, 'year')}
            isClearable={false}
            disabled={loading || data.years.length < 1}
          />
        </Col>
        <Col xs={12} md={4}>
          <Select
            value={data?.periods?.find((e) => e.value === query.periodId)}
            name="period"
            options={data.periods}
            label={t('filters.period.label')}
            placeholder={t('filters.period.placeholder')}
            onChange={handleChangeFilter.bind(null, 'periodId')}
            isClearable={false}
            disabled={loading || data.periods.length < 1}
          />
        </Col>
      </Row>
    </Container>
  );
};

export default StudentWarningsSummaryMainFilter;
